import Constants from 'expo-constants';

/**
 * User-facing app version from app.config.ts, which release-please bumps on every
 * release (`// x-release-please-version`). Never hardcode the version in the UI.
 */
export const APP_VERSION: string = Constants.expoConfig?.version ?? '';
